module.exports = __webpack_public_path__ + "img/eben.4cfaf7c4.jpeg";